document.addEventListener('alpine:init', () => {

	const isCurrentTab = ({
		currentTab
	}, tab) => currentTab === tab;

	Alpine.bind('Tabs', ($data) => ({
		'x-id': () => ['tabs'],
		':id': () => $data.$id('tabs'),
	}));

	Alpine.bind('TabButton', (tab, $data) => ({
		'role': 'tab',
		':aria-controls': () => $data.$id('tabs', `panel-${tab}`),
		':aria-selected': () => isCurrentTab($data, tab),
		':class': () => ({
			'tab--active': isCurrentTab($data, tab),
		}),
		':id': () => $data.$id('tabs', `button-${tab}`),
		':tabindex': () => isCurrentTab($data, tab) ? 0 : -1,
		'@click': () => {
			$data.currentTab = tab;
		},
	}));

	Alpine.bind('TabPanel', (tab, $data) => ({
		'role': 'tabpanel',
		'tabindex': 0,
		':aria-labeledby': () => $data.$id('tabs', `button-${tab}`),
		':hidden': () => !isCurrentTab($data, tab),
		':id': () => $data.$id('tabs', `panel-${tab}`),
	}));
});

document.addEventListener("DOMContentLoaded", function () {
  const tabContainers = document.querySelectorAll('.tabs-container');

  tabContainers.forEach(container => {
    const nav = container.querySelector('.tabs-nav');
    const titles = nav?.querySelector('.tabs-titles');
    if (!titles || container.querySelector('.tabs-nav-wrapper')) return;

    const tabs = Array.from(titles.querySelectorAll('[role="button"]'));

    const wrapper = document.createElement('div');
    wrapper.className = 'tabs-nav-wrapper';

    const btnPrev = document.createElement('button');
    btnPrev.className = 'tabs-nav-arrow prev';
    btnPrev.textContent = '<'; // seta esquerda
    btnPrev.setAttribute('aria-label', 'Anterior');

    const btnNext = document.createElement('button');
    btnNext.className = 'tabs-nav-arrow next';
    btnNext.textContent = '>'; // seta direita
    btnNext.setAttribute('aria-label', 'Próximo');

    wrapper.appendChild(btnPrev);
    wrapper.appendChild(btnNext);
    container.insertBefore(wrapper, nav);

    let currentIndex = tabs.findIndex(t => t.classList.contains('active'));
    if (currentIndex === -1) currentIndex = 0;

    function activateTab(index) {
      if (index < 0 || index >= tabs.length) return;

      currentIndex = index;
      tabs[index].click();

      const tab = tabs[index];
      const offsetLeft = tab.offsetLeft;
      const offsetWidth = tab.offsetWidth;
      const containerWidth = titles.offsetWidth;

      const scrollLeft = offsetLeft - (containerWidth / 2) + (offsetWidth / 2);
      titles.scrollTo({ left: scrollLeft, behavior: 'smooth' });

      updateButtons();
    }

    function updateButtons() {
      btnPrev.disabled = currentIndex <= 0;
      btnNext.disabled = currentIndex >= tabs.length - 1;
    }

    btnPrev.addEventListener('click', () => activateTab(currentIndex - 1));
    btnNext.addEventListener('click', () => activateTab(currentIndex + 1));

    updateButtons();
  });
});

